module.exports = __webpack_public_path__ + "static/2-b2ed736142ac3bcf9083d24274245d93.jpg";